export default __webpack_public_path__ + "static/Wizard_03-095a1be962ff8046c0e01aedd15e9b30.webp";